import { render, staticRenderFns } from "./defaultUserSettingsDialog.vue?vue&type=template&id=08d94387"
import script from "./defaultUserSettingsDialog.vue?vue&type=script&lang=ts"
export * from "./defaultUserSettingsDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports